import regeneratorRuntime from "/app/node_modules/.pnpm/next@12.1.0_b4ec139f952e61d6d44e5ae38927fa76/node_modules/next/dist/compiled/regenerator-runtime/runtime.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable max-len */ // import '@tencent/particle-ui/dist/pui.css';
// import '@tencent/cms-design-component/lib/dist/style/main.css';
import logger from 'common/utils/udp-logger';
import Head from 'next/head';
import { getTips } from 'portal-common/components/LanguagNone/resource/trans-tip';
import React from 'react';
import { getPriceTabData, getTceTableData } from '../apis/buyApi';
import { getPageDetail } from '../apis/cmsApi';
// import { queryFormInfo } from '../apis/formApi';
import GemsRender from '../components/GemsRender';
import OldRender from '../components/OldRender';
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
/**
 * 将 geo HTML 字符串注入到 document head 中
 * 利用 next/head 组件，通过 dangerouslySetInnerHTML 的 script 注入 structured data
 * 通过客户端 script 将其余 meta/link 标签插入 head（SSR 源码中也会包含该 script）
 */ var GeoHead = function(param) {
    var html = param.html;
    if (!html || typeof html !== 'string') return null;
    // base64 解码
    var decodedHtml = Buffer.from(html, 'base64').toString('utf-8');
    // 去除 HTML 注释，只保留有效标签
    var cleanHtml = decodedHtml.replace(/<!--[\s\S]*?-->/g, '').trim();
    if (!cleanHtml) return null;
    var elements = [];
    // 提取 <script type="application/ld+json">...</script> —— 这个 next/head 原生支持
    var scriptRegex = /<script\s+type="application\/ld\+json"[^>]*>([\s\S]*?)<\/script>/gi;
    var match;
    var idx = 0;
    while((match = scriptRegex.exec(cleanHtml)) !== null){
        elements.push(/*#__PURE__*/ _jsx("script", {
            type: "application/ld+json",
            dangerouslySetInnerHTML: {
                __html: match[1]
            }
        }, "geo-ld-".concat(idx)));
        idx += 1;
    }
    // 提取 <link ...> 标签
    var linkRegex = /<link\s([^>]*)\/?>/gi;
    while((match = linkRegex.exec(cleanHtml)) !== null){
        var attrs = {};
        var attrRegex = /(\w+(?:-\w+)?)="([^"]*)"/g;
        var attrMatch = attrRegex.exec(match[1]);
        while(attrMatch !== null){
            var _attrMatch = _slicedToArray(attrMatch, 3), attrName = _attrMatch[1], attrValue = _attrMatch[2];
            var key = attrName === 'hreflang' ? 'hrefLang' : attrName;
            attrs[key] = attrValue;
            attrMatch = attrRegex.exec(match[1]);
        }
        elements.push(/*#__PURE__*/ _jsx("link", _objectSpread({}, attrs), "geo-link-".concat(idx)));
        idx += 1;
    }
    // 提取 <meta ...> 标签
    var metaRegex = /<meta\s([^>]*)\/?>/gi;
    while((match = metaRegex.exec(cleanHtml)) !== null){
        var attrs1 = {};
        var attrRegex1 = /(\w+)="([^"]*)"/g;
        var attrMatch1 = attrRegex1.exec(match[1]);
        while(attrMatch1 !== null){
            var _attrMatch1 = _slicedToArray(attrMatch1, 3), attrName1 = _attrMatch1[1], attrValue1 = _attrMatch1[2];
            attrs1[attrName1] = attrValue1;
            attrMatch1 = attrRegex1.exec(match[1]);
        }
        elements.push(/*#__PURE__*/ _jsx("meta", _objectSpread({}, attrs1), "geo-meta-".concat(idx)));
        idx += 1;
    }
    // 兜底：将未被上面正则匹配到的标签通过 script 动态插入 head
    var remainHtml = cleanHtml.replace(/<script\s+type="application\/ld\+json"[^>]*>[\s\S]*?<\/script>/gi, '').replace(/<link\s[^>]*\/?>/gi, '').replace(/<meta\s[^>]*\/?>/gi, '').trim();
    if (remainHtml) {
        var injectScript = "(function(){var d=document.createElement('div');d.innerHTML=".concat(JSON.stringify(remainHtml), ";var h=document.head;while(d.firstChild){h.appendChild(d.firstChild);}})();");
        elements.push(/*#__PURE__*/ _jsx("script", {
            dangerouslySetInnerHTML: {
                __html: injectScript
            }
        }, "geo-fallback"));
    }
    if (elements.length === 0) return null;
    return(/*#__PURE__*/ _jsx(Head, {
        children: elements
    }));
};
export var getData = function() {
    var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(param) {
        var locale, defaultLocale, eid, isPreview, domains, lg, ref, data, msg, code, isNewEditorData, components, ref1, ref2, ref3, ref4, ref5, ref6, langTip, noticeCom, tceTableItem, ref7, code1, pData, item1, ref8, code2, pData1;
        return regeneratorRuntime.wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    locale = param.locale, defaultLocale = param.defaultLocale, eid = param.eid, isPreview = param.isPreview, domains = param.domains;
                    lg = locale || defaultLocale;
                    _ctx.prev = 2;
                    if (!(eid === 'undefined')) {
                        _ctx.next = 5;
                        break;
                    }
                    return _ctx.abrupt("return", {
                        notFound: true
                    });
                case 5:
                    _ctx.next = 7;
                    return getPageDetail(eid, isPreview);
                case 7:
                    ref = _ctx.sent;
                    data = ref.data;
                    msg = ref.msg;
                    code = ref.code;
                    if (!(!code && data && typeof data === 'object')) {
                        _ctx.next = 36;
                        break;
                    }
                    isNewEditorData = !!data.langPage;
                    components = [];
                    if (isNewEditorData) {
                        ;
                        components = ((ref1 = data.langPage) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[lg]) === null || ref2 === void 0 ? void 0 : ref2.components) || [];
                    } else {
                        ;
                        components = ((ref3 = data.components) === null || ref3 === void 0 ? void 0 : ref3.filter(function(item) {
                            return item.lang === lg;
                        })) || [];
                    }
                    if (components.length === 0) {
                        ;
                        langTip = getTips('express', lg);
                        lg = 'en';
                        components = ((ref4 = data.langPage) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.en) === null || ref5 === void 0 ? void 0 : ref5.components) || ((ref6 = data.components) === null || ref6 === void 0 ? void 0 : ref6.filter(function(item) {
                            return item.lang === lg;
                        })) || [];
                        noticeCom = {
                            id: 'component/Notice',
                            name: 'Notice',
                            key: 999,
                            style: {},
                            commonStyle: {},
                            wrapperStyle: {},
                            data: {
                                noFix: true,
                                longTimeMode: true,
                                noticeDesc: langTip,
                                noticeType: 'notice',
                                transTip: true
                            }
                        };
                        components.unshift(noticeCom);
                    }
                    if (!(components.length === 0)) {
                        _ctx.next = 19;
                        break;
                    }
                    logger.error('notFound', {
                        desc: 'components length == 0',
                        locale: locale,
                        defaultLocale: defaultLocale,
                        eid: eid,
                        isPreview: isPreview
                    });
                    return _ctx.abrupt("return", {
                        notFound: true
                    });
                case 19:
                    tceTableItem = components.find(function(item) {
                        return item.component_id === 'TceTable' && item.lang === lg || item.name === 'TceTable';
                    });
                    if (!tceTableItem) {
                        _ctx.next = 27;
                        break;
                    }
                    _ctx.next = 23;
                    return getTceTableData();
                case 23:
                    ref7 = _ctx.sent;
                    code1 = ref7.code;
                    pData = ref7.data;
                    if (!code1) {
                        tceTableItem.data.tceTableData = pData;
                    } else {
                        logger.error('getTceTableData', {
                            lg: lg,
                            pData: pData,
                            code: code1
                        });
                        // 如果请求异常就删除该组件的显示
                        components.splice(components.indexOf(item1), 1);
                    }
                case 27:
                    item1 = components.find(function(item) {
                        return item.component_id === 'ProductsService' && item.lang === lg || item.name === 'ProductsService';
                    });
                    if (!item1) {
                        _ctx.next = 35;
                        break;
                    }
                    _ctx.next = 31;
                    return getPriceTabData(lg, domains);
                case 31:
                    ref8 = _ctx.sent;
                    code2 = ref8.code;
                    pData1 = ref8.data;
                    if (!code2) {
                        if (isNewEditorData) {
                            item1.data.productsServiceData = pData1;
                        } else {
                            item1.productsServiceData = pData1;
                        }
                    } else {
                        logger.error('getPriceTabData', {
                            lg: lg,
                            pData: pData1,
                            code: code2
                        });
                        // 如果请求异常就删除该组件的显示
                        components.splice(components.indexOf(item1), 1);
                    }
                case 35:
                    return _ctx.abrupt("return", {
                        props: {
                            code: code,
                            msg: msg,
                            lang: lg,
                            isPreview: isPreview,
                            configData: data,
                            domains: domains
                        }
                    });
                case 36:
                    logger.error('notFound', {
                        locale: locale,
                        defaultLocale: defaultLocale,
                        eid: eid,
                        isPreview: isPreview
                    });
                    return _ctx.abrupt("return", {
                        notFound: true
                    });
                case 40:
                    _ctx.prev = 40;
                    _ctx.t0 = _ctx["catch"](2);
                    logger.error('getData', {
                        desc: 'no data',
                        locale: locale,
                        defaultLocale: defaultLocale,
                        eid: eid,
                        isPreview: isPreview,
                        error: _ctx.t0
                    });
                    throw _ctx.t0;
                case 44:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                2,
                40
            ]
        ]);
    }));
    return function getData(_) {
        return _ref.apply(this, arguments);
    };
}();
var pageRenderer = function(props) {
    var code = props.code, configData = props.configData, location = props.location, lang = props.lang, isPreview = props.isPreview, domains = props.domains, other = _objectWithoutProperties(props, [
        "code",
        "configData",
        "location",
        "lang",
        "isPreview",
        "domains"
    ]);
    if (code) {
        return(/*#__PURE__*/ _jsx("div", {}));
    }
    try {
        // ✅ 防御性检查：确保 configData 存在且是对象
        if (!configData || typeof configData !== 'object') {
            logger.error('pageRenderer', {
                code: code,
                configData: configData,
                location: location,
                lang: lang,
                isPreview: isPreview,
                error: 'Invalid configData'
            });
            return(/*#__PURE__*/ _jsx("div", {}));
        }
        var isNewData = !!configData.langPage;
        var pageObject = configData.pageObject;
        // ✅ 防御性检查：确保 pageObject 存在
        if (!pageObject) {
            logger.error('pageRenderer', {
                code: code,
                configData: configData,
                location: location,
                lang: lang,
                isPreview: isPreview,
                error: 'Missing pageObject'
            });
            return(/*#__PURE__*/ _jsx("div", {}));
        }
        if (typeof pageObject === 'string') {
            try {
                pageObject = JSON.parse(pageObject);
            } catch (parseError) {
                logger.error('pageRenderer', {
                    code: code,
                    configData: configData,
                    location: location,
                    lang: lang,
                    isPreview: isPreview,
                    error: "Failed to parse pageObject: ".concat(parseError.message)
                });
                return(/*#__PURE__*/ _jsx("div", {}));
            }
        }
        // ✅ 防御性检查：确保 pageObject.langs 存在
        if (!pageObject.langs || typeof pageObject.langs !== 'object') {
            logger.error('pageRenderer', {
                code: code,
                configData: configData,
                location: location,
                lang: lang,
                isPreview: isPreview,
                error: 'Missing or invalid pageObject.langs'
            });
            return(/*#__PURE__*/ _jsx("div", {}));
        }
        var langInfo = pageObject.langs[lang] || {};
        if (Object.keys(langInfo).length === 0 && pageObject.langs.en) {
            langInfo = pageObject.langs.en;
        }
        return(/*#__PURE__*/ _jsxs("div", {
            children: [
                /*#__PURE__*/ _jsxs(Head, {
                    children: [
                        /*#__PURE__*/ _jsx("title", {
                            children: langInfo.title || ''
                        }),
                        /*#__PURE__*/ _jsx("meta", {
                            name: "description",
                            content: langInfo.description || ''
                        }),
                        /*#__PURE__*/ _jsx("meta", {
                            name: "keywords",
                            content: langInfo.keyword || ''
                        })
                    ]
                }),
                langInfo.geo && /*#__PURE__*/ _jsx(GeoHead, {
                    html: langInfo.geo
                }),
                isNewData ? /*#__PURE__*/ _jsx(GemsRender, _objectSpread({
                    lang: lang,
                    configData: configData,
                    isPreview: isPreview,
                    domains: domains
                }, other)) : /*#__PURE__*/ _jsx(OldRender, {
                    lang: lang,
                    configData: configData,
                    location: location,
                    isPreview: isPreview
                })
            ]
        }));
    } catch (error) {
        logger.error('pageRenderer', {
            code: code,
            configData: configData,
            location: location,
            lang: lang,
            isPreview: isPreview,
            error: error
        });
        throw error;
    }
};
export { pageRenderer };
